<template>
    <nav id="sidebarMenu" class="sidebar d-md-block text-white collapse"  style="background: #065fb4;" data-simplebar>
        <div class="sidebar-inner">
            <div style="background:#fff;" class="user-card d-flex  align-items-center justify-content-between justify-content-md-center pb-4">
                <div class="d-flex align-items-center">
                    <div class=""> 
                        <img :src="site_logo.image" class="" :alt="site_logo.image">
                    </div>
                </div>
                <div class="collapse-close ">
                    <a href="#sidebarMenu" class="" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="true" aria-label="Toggle navigation"></a>
                </div>
            </div>
            <ul class="nav flex-column px-4 pt-3" style="background: #065fb4; opacity: 01;">
                <li class="nav-item  active ">
                    <router-link exact :to="{name: 'index'}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-dashboard"></span></span>
                        <span>Dashboard</span>
                    </router-link>
                </li>
                <li class="nav-item ">
                    <router-link :to="{name: 'index', params: { page: 'popup_banner' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-image"></span></span>
                        <span>Popup Banner</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'ADMINS' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'admins' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-user"></span></span>
                        <span>Admins</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'COUPONS' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'CouponVue' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-percent"></span></span>
                        <span>Coupon</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'BULK UPLOAD' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'BulkUploadProductVue' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-table"></span></span>
                        <span>Bulk Upload</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'DELIVERY CHARGES' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'DeliveryCharge' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-percent"></span></span>
                        <span>Delivery Charges</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'ORDER' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'Order' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-first-order"></span></span>
                        <span>Order</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'CATEGORY' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'category' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-list-alt"></span></span>
                        <span>Category</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'OPTIONS' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'Options' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-list-alt"></span></span>
                        <span>Options</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'OPTION VALUES' && e.has_permission == true ).length">
                    <router-link :to="{name : 'index', params: { page: 'OptionsValues'}}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-list-alt"></span></span>
                        <span>Option Values</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'OPTION VALUE TYPES' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'OptionValueTypes' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-list-alt"></span></span>
                        <span>Option Value Types</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'QUANTITY' && e.has_permission == true ).length">
                    <router-link :to="{name : 'index', params: { page: 'Quantity'}}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-list-alt"></span></span>
                        <span>Quantity</span>
                    </router-link>
                </li>
                <li class="nav-item " >
                    <router-link :to="{name : 'index', params: { page: 'SEOKeywords'}}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-list-alt"></span></span>
                        <span>SEO-Keywords</span>
                    </router-link>
                </li>
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'CONTACT REQUEST' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'Contact' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-paper-plane"></span></span>
                        <span>Contact Request</span>
                    </router-link>
                </li>
                 <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'SITE USERS' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'users' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-user"></span></span>
                        <span>Site Users</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="permissions && permissions.filter(e => (e.section == 'TESTIMONIALS' && e.has_permission == true) || (e.section == 'BLOGS' && e.has_permission == true) ).length">
                    <span class="nav-link  collapsed  d-flex justify-content-between align-items-center" data-toggle="collapse" data-target="#submenu-app2">
                    <span>
                    <span class="sidebar-icon"><span class="fa fa-table"></span></span>
                    All Menus
                    </span>
                    <span class="link-arrow"><span class="fa fa-chevron-right"></span></span>
                    </span>
                    <div class="multi-level collapse " role="list" id="submenu-app2" aria-expanded="false" v-if="permissions && permissions.filter(e => e.section == 'TESTIMONIALS' && e.has_permission == true ).length">
                        <ul class="flex-column nav">
                            <li class="nav-item "><router-link class="nav-link" :to="{name: 'index', params: { page: 'testimonial' }}"><span>Testimonial</span></router-link></li>
                            </ul>
                    </div>
                    <div class="multi-level collapse " role="list" id="submenu-app2" aria-expanded="false" v-if="permissions && permissions.filter(e => e.section == 'BLOGS' && e.has_permission == true ).length">
                        <ul class="flex-column nav">
                            <li class="nav-item "><router-link class="nav-link" :to="{name: 'index', params: { page: 'blogs' }}"><span>Blogs</span></router-link></li>
                            </ul>
                    </div>
                </li> 
                <li class="nav-item " v-if="permissions && permissions.filter(e => e.section == 'SITE LOGO' && e.has_permission == true ).length">
                    <router-link :to="{name: 'index', params: { page: 'logo' }}" class="nav-link">
                        <span class="sidebar-icon"><span class="fa fa-globe"></span></span>
                        <span>Site Logo</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>
<script>
// import axios from 'axios'
export default {
    data() {
        return {
            site_logo: [],
                username: '',
                password: '',
                reminder: true,
                permissions: null,
                // URL_ROOT:'https://5ineprojects.com/Rapidea/backend/api/'
        }
    },
    mounted() {
        this.site_logos()
        if (localStorage.getItem('permissions')) {
            this.permissions = JSON.parse(localStorage.getItem('permissions'))
            this.permissions.forEach(e => {
                console.log(e.section);
            })
        }
    },
    methods: {
        logout() {
                localStorage.removeItem("admin");
                localStorage.removeItem("token");
                localStorage.removeItem("latitude");
                localStorage.removeItem("longitude");
                this.$router.push({ name: 'loginuser' })
                this.$router.go("/");
                localStorage.removeItem("isAdmin");
        },
        site_logos() {
                const axios = require('axios')
                var self = this
                axios.post(this.$root.URL_ROOT + 'api.php', {
                    type:'site_logo'
                }).then(function (response) {
                //console.log(response)
                    var data = response.data
                    self.site_logo = data.data
                })
        },
    },

}
</script>



